import { render, staticRenderFns } from "./contractLottery.vue?vue&type=template&id=565b3718&"
import script from "./contractLottery.vue?vue&type=script&lang=js&"
export * from "./contractLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports